import { useQuery } from 'react-query';
import request from '../helpers/request';
import { queryKeys } from './queryKeys';

export const getRequestComments = async (requestId) => {
  return await request.get(
    `/Request/request_notes/${requestId}`,
    {},
    'При загрузке комментариев произошла ошибка',
    []
  );
};

const useRequestComments = (requestId, options) =>
  useQuery(
    queryKeys.requestComments(requestId),
    () => getRequestComments(requestId),
    {
      enabled: !!requestId,
      ...options,
    }
  );

export default useRequestComments;
